import { defineComponent as i, openBlock as t, createElementBlock as o, mergeProps as u, unref as a, renderSlot as g, createElementVNode as e, createCommentVNode as H } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const V = { key: 0 }, f = { key: 1 }, h = { key: 2 }, w = { key: 3 }, k = { key: 4 }, A = { key: 5 }, M = {
  name: "ScalarIconArrowElbowRightUp"
}, _ = /* @__PURE__ */ i({
  ...M,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = m(s);
    return (p, l) => (t(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, a(d)), [
      g(p.$slots, "default"),
      a(n) === "bold" ? (t(), o("g", V, l[0] || (l[0] = [
        e("path", { d: "M224.49,104.49a12,12,0,0,1-17,0L180,77V192a12,12,0,0,1-12,12H24a12,12,0,0,1,0-24H156V77l-27.51,27.52a12,12,0,1,1-17-17l48-48a12,12,0,0,1,17,0l48,48A12,12,0,0,1,224.49,104.49Z" }, null, -1)
      ]))) : a(n) === "duotone" ? (t(), o("g", f, l[1] || (l[1] = [
        e("path", {
          d: "M216,96H120l48-48Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M221.66,90.34l-48-48a8,8,0,0,0-11.32,0l-48,48A8,8,0,0,0,120,104h40v80H24a8,8,0,0,0,0,16H168a8,8,0,0,0,8-8V104h40a8,8,0,0,0,5.66-13.66ZM139.31,88,168,59.31,196.69,88Z" }, null, -1)
      ]))) : a(n) === "fill" ? (t(), o("g", h, l[2] || (l[2] = [
        e("path", { d: "M223.39,99.06A8,8,0,0,1,216,104H176v88a8,8,0,0,1-8,8H24a8,8,0,0,1,0-16H160V104H120a8,8,0,0,1-5.66-13.66l48-48a8,8,0,0,1,11.32,0l48,48A8,8,0,0,1,223.39,99.06Z" }, null, -1)
      ]))) : a(n) === "light" ? (t(), o("g", w, l[3] || (l[3] = [
        e("path", { d: "M220.24,100.24a6,6,0,0,1-8.48,0L174,62.49V192a6,6,0,0,1-6,6H24a6,6,0,0,1,0-12H162V62.49l-37.76,37.75a6,6,0,0,1-8.48-8.48l48-48a6,6,0,0,1,8.48,0l48,48A6,6,0,0,1,220.24,100.24Z" }, null, -1)
      ]))) : a(n) === "regular" ? (t(), o("g", k, l[4] || (l[4] = [
        e("path", { d: "M221.66,101.66a8,8,0,0,1-11.32,0L176,67.31V192a8,8,0,0,1-8,8H24a8,8,0,0,1,0-16H160V67.31l-34.34,34.35a8,8,0,0,1-11.32-11.32l48-48a8,8,0,0,1,11.32,0l48,48A8,8,0,0,1,221.66,101.66Z" }, null, -1)
      ]))) : a(n) === "thin" ? (t(), o("g", A, l[5] || (l[5] = [
        e("path", { d: "M218.83,98.83a4,4,0,0,1-5.66,0L172,57.66V192a4,4,0,0,1-4,4H24a4,4,0,0,1,0-8H164V57.66L122.83,98.83a4,4,0,0,1-5.66-5.66l48-48a4,4,0,0,1,5.66,0l48,48A4,4,0,0,1,218.83,98.83Z" }, null, -1)
      ]))) : H("", !0)
    ], 16));
  }
});
export {
  _ as default
};
